import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoMdAdd, IoMdLogOut, IoMdAlbums, IoIosListBox } from 'react-icons/io';
import { RiFileEditLine } from 'react-icons/ri';
import { userCreatedPinsQuery, userQuery, userCreatedPinsQueryNonUser } from '../../utils/data';
import { client } from '../../client';
import MasonryLayout from '../MasonryLayout';
import { fetchUser } from '../../utils/FetchUser';
import Spinner from '../Spinner';
import UserSettings from './UserSettings';
import { useAlert } from 'react-alert';
import UserInfo from './UserInfo';
import { getAuth, signOut } from "firebase/auth";
import ProfileImages from './ProfileImages';

const activeBtnStyles = 'bg-indigo-500 text-black font-bold p-2 rounded-full w-auto m-1 outline-none';
const notActiveBtnStyles = 'bg-primary text-black font-bold p-2 rounded-full w-auto m-1 outline-none';

const UserProfile = ({setView}) => {
    const [user, setUser] = useState(null);
    const [pins, setPins] = useState();
    const [text, setText] = useState('Created');
    const [activeBtn, setActiveBtn] = useState('created');
    const [options, setOptions] = useState(false);
    const navigate = useNavigate();
    const alert = useAlert();
    const { userId } = useParams();
    const User = fetchUser();

    useEffect(() => {
        const query = userQuery(userId);
        client.fetch(query).then((data) => {
            setUser(data[0]);
            setView("Profile");
        });
    }, [userId]);

    useEffect(() => {
        if (text === 'Created') {
            if (User?.sub === userId) {
                setOptions(false);
                const createdPinsQuery = userCreatedPinsQuery(userId);

                client.fetch(createdPinsQuery).then((data) => {
                    setPins(data);
                });
            }
            else {
                setOptions(false);
                const id = `"${User?.sub}"`;
                const createdPinsQuery = userCreatedPinsQueryNonUser(userId, id);

                client.fetch(createdPinsQuery).then((data) => {
                    setPins(data);
                });
            }

        } else {
            setOptions(true);
        }
    }, [text, userId]);

    const handleSignOut = (event) => {
        const auth = getAuth();
        localStorage.clear();
        
        signOut(auth).then(() => {
        }).catch((error) => {
            // An error happened.
            console.log("error");
            console.log(error);
        });
       
    }

    useEffect(() => {
        const query = '*[_id== $id]';
        const params = { id: userId };
        const subscription = client
            .listen(query, params)
            .subscribe(update => {
                const newUser = update.result;
                console.log("New User")
                console.log(newUser);
                setUser(newUser);
            })

        return () => {
            subscription.unsubscribe();
        }
    }, [])



    if (!User) return <Spinner message="Loading profile" />;

    return (
        <div className="relative pb-2 h-full justify-center items-center">
            <div className="flex flex-col pb-5">
                <div className="relative flex flex-col mb-4">
                    <ProfileImages user={user} userId={userId} />

                    <h1 className="font-bold text-3xl text-center mt-3">
                        {user?.userName}
                    </h1>

                </div>
                <div className="flex justify-center text-center mb-2">
                    <div className='p-1'>
                        <button
                            type="button"
                            onClick={(e) => {
                                setText('created');
                                setActiveBtn('created');
                            }}
                            className={`${activeBtn === 'created' ? activeBtnStyles : notActiveBtnStyles}`}
                        >
                            <IoMdAlbums />
                        </button>
                        <p className='text-xs'>Posts</p>
                    </div>
                    <div className='p-1'>
                        <button
                            type="button"
                            onClick={(e) => {
                                setText(e.target.textContent);
                                setActiveBtn('info');
                            }}
                            className={`${activeBtn === 'info' ? activeBtnStyles : notActiveBtnStyles}`}
                        >
                            <IoIosListBox />
                        </button>
                        <p className='text-xs'>Info</p>
                    </div>
                    {userId === User?.sub && (
                        <>
                            <div className='p-1'>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        setText(e.target.textContent);
                                        setActiveBtn('setting');
                                    }}
                                    // className={`${activeBtn === 'setting' ? 'bg-red-500 text-white font-bold p-2 rounded-full w-auto m-1 outline-none' : 'bg-primary text-black font-bold p-2 rounded-full w-auto m-1 outline-none'}`}
                                    className={`${activeBtn === 'setting' ? activeBtnStyles : notActiveBtnStyles}`}
                                >
                                    <RiFileEditLine />
                                </button>
                                <p className='text-xs'>edit</p>
                            </div>
                            <div className='p-1'>
                                <button
                                    type="button"
                                    className={`${activeBtnStyles}`}
                                    onClick={(e) => {
                                        alert.show(
                                            <div style={{ color: 'white' }}>
                                                Log Out?
                                                <div className='justify-center'>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            handleSignOut(e);
                                                        }}
                                                        className="bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none justify-center"
                                                    >
                                                        Confirm
                                                    </button>
                                                </div>
                                            </div>);
                                    }}

                                >
                                    <IoMdLogOut />
                                </button>
                                <p className='text-xs'>Log Out</p>
                            </div>
                        </>
                    )}
                </div>
                {activeBtn === 'setting' &&
                    <UserSettings user={user && user} />
                }
                {activeBtn === 'created' &&
                    <div className="px-2">
                        <MasonryLayout pins={pins} />
                    </div>
                }
                {activeBtn === 'info' &&
                    <div className="px-2">
                        <UserInfo user={user && user} />
                    </div>
                }

                {pins?.length === 0 && (
                    <div className="flex justify-center font-bold items-center w-full text-1xl mt-2">
                        No Pins Found!
                    </div>
                )}
            </div>

        </div >
    );
};

export default UserProfile;
